// ** MUI Imports
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useAuth } from 'src/hooks/useAuth'
import { AuthContext } from 'src/context/AuthContext'
import { useEffect, useState } from 'react'

const FallbackSpinner = ({ sx }) => {
  const { favUrlFromSettings } = useAuth(AuthContext) // Assuming favUrlFromSettings comes from the AuthContext

  const [favUrl, setFavUrl] = useState('') // Default image as a fallback

  useEffect(() => {
    // Fetch the favUrl from localStorage or set to default
    const storedFavUrl = localStorage.getItem('favUrl') || favUrlFromSettings || '/images/cxpify-favicon-2.jpg'

    setFavUrl(storedFavUrl)

  }, [favUrlFromSettings]) // Add favUrlFromSettings as a dependency to refresh when it changes

return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        ...sx
      }}
    >
      <img src={favUrl ? favUrl : '/images/cxpify-favicon-2.jpg'} alt='TotientCXP Logo' width={90} height={80} />
      

      <CircularProgress disableShrink sx={{ mt: 6 }} />
    </Box>
  )
}

export default FallbackSpinner
